import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {WidgetSettingsService} from '../../../components/layout/widget/widget-settings-service';
import {DexLpWidgetSettings, DexLpWidgetSettingsDef} from './dex-lp-widget-settings';

@Injectable()
export class DexLpWidgetSettingsService implements WidgetSettingsService {

    public getDefaultSettings(): Observable<DexLpWidgetSettings> {
        const defaultWidgetSettings: DexLpWidgetSettings = {
            title:          null,
            expandedSymbol: undefined
        };

        return of(defaultWidgetSettings);
    }

    public fromDefinition(settingsDef: DexLpWidgetSettingsDef): Observable<DexLpWidgetSettings> {
        return of<DexLpWidgetSettings>({
            title:          settingsDef.title,
            expandedSymbol: settingsDef.expandedSymbol || undefined
        });
    }

    public toDefinition(settings: DexLpWidgetSettings): DexLpWidgetSettingsDef {
        return {
            title:          settings.title,
            expandedSymbol: settings.expandedSymbol || undefined
        };
    }

}
